<div class="flex flex-col w-full min-h-full bg-default">

    <!-- 1. Custom Header (Theme Color BG, Logos, White Separator) -->
    <header class="h-16 flex items-center justify-start px-6 md:px-8 shadow-lg sticky top-0 z-40"
            style="background-color: rgb(126 71 152 / 95%);">

        <div class="max-w-[1400px] mx-auto text-white">
            <div class="flex items-center space-x-4">
                <!-- Main Logo -->
                <img
                    src="https://naturals.mykixa.com/images/kixa-offered-b.png"
                    alt="Main Logo"
                    class="h-10 sm:h-12 object-contain"
                >

                <!-- Vertical White Line Separator -->
                <div class="w-px h-8 bg-white opacity-70"></div>

                <!-- Partner Logo -->
                <img
                    src="https://media.myaltituderewards.com/logos/naturals_header_logo.png"
                    alt="Partner Logo"
                    class="h-15 sm:h-15 object-contain"
                >
            </div>
        </div>
    </header>


    <!-- Loading Bar -->
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate" class="fixed top-0 left-0 right-0 z-50"></mat-progress-bar>

    <!-- STATE 1: Input / Selection -->
    <ng-container *ngIf="!showStats; else statsView">
        <div class="flex flex-col flex-auto items-center justify-center p-6 md:p-8" @fadeIn>
            <div class="w-full max-w-xl">
                <div class="text-center mb-10">
                    <!-- Custom Background/Text Color -->
                    <div class="inline-flex items-center justify-center p-6 rounded-full mb-6" style="background-color: rgba(126, 71, 152, 0.1);">
                        <mat-icon class="icon-size-12 text-[48px] !w-[48px] !h-[48px] leading-[48px]" style="color: #7E4798;">groups</mat-icon>
                    </div>
                    <h1 class="text-4xl font-extrabold tracking-tight text-default">
                        Location Leaderboard
                    </h1>
                    <p class="mt-3 text-lg text-secondary">
                        Track performance, monitor growth, and check standings.
                    </p>
                </div>

                <div class="bg-card rounded-2xl shadow overflow-hidden p-8">
                    <form [formGroup]="form" (ngSubmit)="fetchStats()">
                        <div class="flex flex-col gap-6">
                            <mat-form-field class="w-full fuse-mat-no-subscript" appearance="outline">
                                <mat-label>Leaderboard Key</mat-label>
                                <mat-icon matPrefix class="icon-size-5 mr-2">vpn_key</mat-icon>
                                <input matInput formControlName="ds_leaderboardkey" placeholder="XXXXXXXX" class="uppercase font-bold tracking-widest">
                                <button *ngIf="form.get('ds_leaderboardkey')?.value"
                                        mat-icon-button
                                        matSuffix
                                        type="button"
                                        (click)="form.reset()">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>

                            <!-- Apply custom button theme class -->
                            <button
                                mat-stroked-button
                                class="mat-button-themed w-full !h-12 !text-lg !rounded-xl"
                                type="submit"
                                [disabled]="form.invalid || isLoading">
                                Launch Dashboard
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Recent Searches / History -->
                <div class="mt-8 text-center" *ngIf="false && savedCodes.length > 0">
                    <p class="text-sm font-medium text-secondary mb-3">Recent Searches:</p>
                    <mat-chip-listbox>
                        <!-- Apply custom chip theme class -->
                        <mat-chip-row *ngFor="let code of savedCodes" (click)="selectCode(code)" class="mat-chip-themed cursor-pointer">
                            {{ code }}
                            <button matChipRemove (click)="removeCodeFromHistory(code, $event)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-listbox>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- STATE 2: Dashboard View -->
    <ng-template #statsView>
        <div class="flex flex-col w-full p-6 md:p-8 space-y-8 max-w-[1400px] mx-auto flex-grow" @fadeIn>

            <!-- Top Navigation -->
            <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                    <h2 class="text-3xl font-extrabold text-default flex items-center gap-3">
                        {{ title }}
                        <span class="px-2.5 py-0.5 rounded-full bg-green-100 text-green-800 dark:bg-green-500/20 dark:text-green-400 text-xs font-bold uppercase tracking-wide">
                            Active
                        </span>
                    </h2>
                    <p class="text-secondary font-medium">Performance Overview</p>
                </div>
                <div class="flex gap-3">
                    <!-- Apply custom button theme class -->
                    <button mat-stroked-button (click)="fetchStats()" class="mat-button-themed">
                        <mat-icon class="icon-size-5 mr-2">refresh</mat-icon> Refresh
                    </button>
                    <button mat-button color="warn" (click)="resetView()">
                        <mat-icon class="icon-size-5 mr-2">logout</mat-icon> Exit
                    </button>
                </div>
            </div>

            <!-- KPI Grid -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

                <!-- KPI 1: Total - Apply Main Theme Color Background -->
                <div class="relative overflow-hidden rounded-2xl p-6 text-white shadow-lg sm:col-span-2 lg:col-span-1"
                     style="background-color: rgb(126 71 152 / 95%);">
                    <mat-icon class="absolute -right-6 -top-6 text-white opacity-20 text-[100px] !w-[100px] !h-[100px] leading-none pointer-events-none">
                        show_chart
                    </mat-icon>
                    <div class="relative z-10">
                        <div class="flex items-center mb-1">
                            <p class="opacity-80 font-medium">Total Signups</p>
                            <mat-icon class="icon-size-4 ml-2 opacity-60 hover:opacity-100 cursor-help transition-opacity"
                                      matTooltip="Combined total of Standard and Subscription signups across the selected period.">
                                help_outline
                            </mat-icon>
                        </div>
                        <h3 class="text-4xl font-extrabold tracking-tight">{{ totalSignups }}</h3>
                        <div class="mt-4 flex items-center text-sm bg-black/10 w-fit px-3 py-1 rounded-full backdrop-blur-sm">
                            <mat-icon class="icon-size-4 mr-1.5">calendar_today</mat-icon>
                            <span>Last 5 Weeks</span>
                        </div>
                    </div>
                </div>

                <!-- KPI 2: Standard (No theme color change needed) -->
                <div class="bg-card rounded-2xl p-6 shadow border border-gray-100 dark:border-gray-700 flex flex-col justify-between">
                    <div class="flex justify-between items-start">
                        <div>
                            <div class="flex items-center mb-1">
                                <p class="text-secondary font-medium">Non Paying Subscriptions</p>
                                <mat-icon class="icon-size-4 ml-2 text-hint hover:text-primary cursor-help transition-colors"
                                          matTooltip="Signups that do not include a recurring membership (e.g., Pay-as-you-go).">
                                    help_outline
                                </mat-icon>
                            </div>
                            <h3 class="text-3xl font-bold text-default">{{ totalStandard }}</h3>
                        </div>
                        <div class="p-2 bg-gray-100 dark:bg-gray-700 rounded-full text-gray-600">
                            <mat-icon class="icon-size-6">person_outline</mat-icon>
                        </div>
                    </div>
                    <p class="mt-2 text-sm text-hint">Non-subscription signups</p>
                </div>

                <!-- KPI 3: Subscriptions - Apply Main Theme Color -->
                <div class="bg-card rounded-2xl p-6 shadow border border-gray-100 dark:border-gray-700 flex flex-col justify-between">
                    <div class="flex justify-between items-start">
                        <div>
                            <div class="flex items-center mb-1">
                                <p class="text-secondary font-medium">Paying Subscriptions</p>
                                <!-- Apply theme color to tooltip hover -->
                                <mat-icon class="icon-size-4 ml-2 text-hint cursor-help transition-colors"
                                          style="--tw-text-opacity: 1; color: #7E4798;"
                                          matTooltip="New members who have signed up for a recurring billing plan.">
                                    help_outline
                                </mat-icon>
                            </div>
                            <!-- Apply theme color to number -->
                            <h3 class="text-3xl font-bold" style="color: #7E4798;">{{ totalSubs }}</h3>
                        </div>
                        <!-- Apply theme color to icon background and icon color -->
                        <div class="p-2 rounded-full" style="background-color: rgba(126, 71, 152, 0.1);">
                            <mat-icon class="icon-size-6" style="color: #7E4798;">card_membership</mat-icon>
                        </div>
                    </div>
                    <p class="mt-2 text-sm text-hint">Paid memberships</p>
                </div>

                <!-- KPI 4: Ranking (No theme color change needed) -->
                <div class="bg-card rounded-2xl p-6 shadow border border-gray-100 dark:border-gray-700 flex flex-col justify-between">
                    <div class="flex justify-between items-start">
                        <div>
                            <div class="flex items-center mb-1">
                                <p class="text-secondary font-medium">Current Leader</p>
                                <mat-icon class="icon-size-4 ml-2 text-hint hover:text-amber-500 cursor-help transition-colors"
                                          matTooltip="The branch currently holding the #1 spot on the global leaderboard.">
                                    help_outline
                                </mat-icon>
                            </div>
                            <h3 class="text-xl font-bold text-default truncate w-full" [matTooltip]="statsData?.ar_absoluteleaderboard[0]?.ds_title">
                                {{ statsData?.ar_absoluteleaderboard[0]?.ds_title || 'N/A' }}
                            </h3>
                        </div>
                        <div class="p-2 bg-amber-50 dark:bg-amber-900/20 rounded-full text-amber-600">
                            <mat-icon class="icon-size-6">emoji_events</mat-icon>
                        </div>
                    </div>
                    <p class="mt-2 text-sm font-bold text-amber-600">
                        Peak Week: {{ bestWeek }}
                    </p>
                </div>
            </div>

            <!-- Content Split (Charts & Leaderboard) -->
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">

                <!-- Main Chart Section -->
                <div class="lg:col-span-2 bg-card rounded-2xl shadow p-6 flex flex-col">
                    <div class="flex items-center mb-6">
                        <h3 class="text-lg font-bold text-default">Signups per week</h3>
                        <mat-icon class="icon-size-5 ml-2 text-hint hover:text-primary cursor-help transition-colors"
                                  matTooltip="Visualizes the volume of new signups per week, separated by Standard vs Subscription.">
                            help_outline
                        </mat-icon>
                    </div>
                    <div class="flex-auto w-full h-80">
                        <apx-chart
                            class="w-full h-full"
                            [series]="chartOptions.series"
                            [chart]="chartOptions.chart"
                            [xaxis]="chartOptions.xaxis"
                            [stroke]="chartOptions.stroke"
                            [tooltip]="chartOptions.tooltip"
                            [dataLabels]="chartOptions.dataLabels"
                            [legend]="chartOptions.legend"
                            [grid]="chartOptions.grid"
                            [colors]="chartOptions.colors"
                            [yaxis]="chartOptions.yaxis"
                        ></apx-chart>
                    </div>
                </div>

                <!-- Absolute Leaderboard Section (No theme color change needed) -->
                <div class="lg:col-span-1 bg-card rounded-2xl shadow flex flex-col overflow-hidden max-h-[500px]">
                    <div class="p-6 border-b border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800 flex items-center justify-between">
                        <h3 class="text-lg font-bold text-default flex items-center">
                            <mat-icon class="icon-size-5 mr-2 text-amber-500">leaderboard</mat-icon>
                            Leaderboard
                        </h3>
                        <mat-icon class="icon-size-5 text-hint hover:text-primary cursor-help transition-colors"
                                  matTooltip="Rankings based on total accumulated performance to date.">
                            help_outline
                        </mat-icon>
                    </div>

                    <div class="flex-1 overflow-y-auto custom-scrollbar p-0">
                        <div *ngFor="let item of statsData.ar_absoluteleaderboard; let i = index"
                             class="shine-container relative flex flex-col justify-center px-6 py-4 border-b border-gray-100 dark:border-gray-800 last:border-0 transition-all"
                             [ngClass]="{
                                 'bg-gradient-to-r from-amber-500 to-orange-500 shadow-md transform scale-[1.02] z-10 border-0 my-1 mx-2 rounded-xl': i === 0,
                                 'bg-slate-50 dark:bg-slate-800 border-l-4 border-slate-400': i === 1,
                                 'bg-orange-50 dark:bg-orange-900/20 border-l-4 border-orange-400': i === 2,
                                 'hover:bg-gray-50 dark:hover:bg-gray-700/50': i > 2
                             }">

                            <!-- Shine Effect only for #1 -->
                            <div *ngIf="i === 0" class="shine-effect absolute inset-0 z-0"></div>

                            <div class="flex items-center relative z-10 w-full">

                                <!-- Rank Indicator -->
                                <div class="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full font-black text-lg mr-4 shadow-sm"
                                     [ngClass]="{
                                         'bg-white text-amber-600 ring-4 ring-white/30 animate-rank-float': i === 0,
                                         'bg-slate-200 text-slate-600': i === 1,
                                         'bg-orange-200 text-orange-700': i === 2,
                                         'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400 w-8 h-8 text-sm': i > 2
                                     }">
                                    <span *ngIf="i === 0">1</span>
                                    <span *ngIf="i > 0">{{ item.place }}</span>
                                </div>

                                <!-- Content Container -->
                                <div class="flex-1 min-w-0 flex flex-col">

                                    <!-- FLASHY LABELS for Top 3 -->
                                    <div *ngIf="i === 0" class="text-[10px] font-black tracking-widest text-white/90 uppercase mb-0.5 flex items-center gap-1">
                                        <mat-icon class="icon-size-3">workspace_premium</mat-icon>
                                        Current Leader
                                    </div>
                                    <div *ngIf="i === 1" class="text-[10px] font-bold tracking-wider text-slate-500 uppercase mb-0.5">
                                        Runner Up
                                    </div>
                                    <div *ngIf="i === 2" class="text-[10px] font-bold tracking-wider text-orange-500 uppercase mb-0.5">
                                        3rd Place
                                    </div>

                                    <!-- Name -->
                                    <p class="truncate transition-all duration-300"
                                       [ngClass]="{
                                           'text-white text-xl font-black uppercase tracking-tight': i === 0,
                                           'text-slate-800 dark:text-slate-200 font-bold text-base': i === 1,
                                           'text-orange-900 dark:text-orange-100 font-bold text-base': i === 2,
                                           'text-default font-medium text-sm': i > 2
                                       }">
                                        {{ item.ds_title }}
                                    </p>
                                </div>

                                <!-- Trophy/Medal Icons (Right Side) -->
                                <div *ngIf="i < 3" class="ml-2 relative z-10 opacity-90">
                                    <!-- Gold Crown -->
                                    <mat-icon *ngIf="i === 0" class="text-white drop-shadow-md text-[32px] !w-[32px] !h-[32px] leading-none animate-rank-float">emoji_events</mat-icon>
                                    <!-- Silver Medal -->
                                    <mat-icon *ngIf="i === 1" class="text-slate-400 icon-size-6">military_tech</mat-icon>
                                    <!-- Bronze Medal -->
                                    <mat-icon *ngIf="i === 2" class="text-orange-400 icon-size-6">military_tech</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Progressive Leaderboard (Full Width) -->
                <div class="lg:col-span-3 bg-card rounded-2xl shadow p-6 flex flex-col" *ngIf="rankChartOptions">
                    <div class="flex items-center justify-between mb-4">
                        <div class="flex items-center">
                            <div>
                                <h3 class="text-lg font-bold text-default">Weekly Ranking History</h3>
                                <p class="text-sm text-secondary">Track position changes over time</p>
                            </div>
                            <mat-icon class="icon-size-5 ml-2 mb-4 text-hint hover:text-primary cursor-help transition-colors"
                                      matTooltip="A 'Bump Chart' showing rank volatility. Higher lines indicate a better rank (Rank #1 is at the top). Crossing lines indicate a change in position.">
                                help_outline
                            </mat-icon>
                        </div>
                        <mat-icon class="text-secondary icon-size-6">timeline</mat-icon>
                    </div>

                    <div class="flex-auto w-full h-80">
                        <apx-chart
                            class="w-full h-full"
                            [series]="rankChartOptions.series"
                            [chart]="rankChartOptions.chart"
                            [xaxis]="rankChartOptions.xaxis"
                            [yaxis]="rankChartOptions.yaxis"
                            [stroke]="rankChartOptions.stroke"
                            [tooltip]="rankChartOptions.tooltip"
                            [grid]="rankChartOptions.grid"
                            [colors]="rankChartOptions.colors"
                            [legend]="rankChartOptions.legend"
                        ></apx-chart>
                    </div>
                </div>

            </div>
        </div>
    </ng-template>

    <!-- 3. Custom Footer (Secondary Color BG, White Text, Left Logo) -->

    <footer class="py-8 px-6 md:px-8 border-t" style="background-color: #7E4798;">
        <div class="max-w-[1400px] mx-auto text-white">
            <!-- Row -->
            <div class="grid grid-cols-[auto_1fr] items-center gap-4">
                <img
                    src="https://naturals.mykixa.com/images/kixa-blackold.png"
                    alt="Footer Logo"
                    class="h-12 object-contain"
                />

                <p class="flex-1 text-sm font-medium text-right">
                    Exclusive lifestyle & travel benefits for<br> members worldwide.
                </p>
            </div>

            <!-- Separator -->
            <div class="h-px my-4" style="background-color: rgba(255, 255, 255, 0.3);"></div>

            <!-- Copyright -->
            <div class="text-xs text-center" style="color: rgba(255, 255, 255, 0.7);">
                © 2025 Altitude Rewards, LLC. All Rights Reserved.
                <br />
                “KIXA™” and “KIXAConnect™” are trademarks of Altitude Rewards, LLC.
            </div>
        </div>
    </footer>

</div>
